import React from "react";
import { formatDateWithTime, formatDateWithWeekday } from "helpers/date";
import Modal from "components/modal";
import useToggle from "hooks/useToggle";

const CannotSeePackage = () => {
	const [showMore, toggle] = useToggle();
	return (
		<div>
			<button className="underline mt-2" onClick={toggle}>Don&apos;t see your package?</button>
			{showMore &&
				<div className="bg-[#EEEEEE] p-3">
					<div className="flex justify-between mb-2">
						<h6 className="font-bold">What to do if you don&apos;t see your package</h6>
						<button onClick={toggle}>x</button>
					</div>
					<div>
						Please check your front and back porches, side doors,
						garage areas and with neighbors to make sure your package
						wasn&apos;t hidden or delivered to the wrong address.
						If your package hasn&apos;t turned up in 2 more days please contact us.
					</div>
				</div>}
		</div>
	);
};

const LatestActivity = ({ activity }) => {
	const { date, time } = formatDateWithTime(activity?.scanned_at);
	return (
		<div>
			<p className="uppercase text-sm font-bold text-darkGray">Latest Activity</p>
			{activity?.scanned_at && <p><strong>{date}</strong> {time}</p>}
			<p>{activity?.message}</p>
			<p className="capitalize">
				{activity?.location?.city}{activity?.location?.city != null ? ", " : ""}{activity?.location?.state}
			</p>
		</div>
	);
};

const OrderStatusHistory = ({ activities }) => {
	const [showHistory, toggleHistory] = useToggle();

	return (
		<>
			<button className="btn-primary w-full my-3" onClick={toggleHistory}>Show history</button>
			<Modal title="History" isOpen={showHistory} close={toggleHistory} className="max-w-screen-sm">
				<div className="flex flex-col-reverse gap-5 p-4">
					{activities.map((activity, i) => {
						const { date, time } = formatDateWithTime(activity?.scanned_at);
						return (
							<div key={i}>
								{activity?.scanned_at && <p><strong>{date}</strong> {time}</p>}
								<p>{activity?.message}</p>
								<p className="capitalize">
									{activity?.location?.city}{activity?.location?.city != null ? ", " : ""}
									{activity?.location?.state}
								</p>
							</div>
						);
					})}
				</div>
			</Modal>
		</>
	);
};

const OrderStatus = ({ order }) => {
	if (!order.shipments.length) return <h4 className="text-center">Order placed</h4>;

	const shipment = order.shipments[0];

	const estimatedDeliveryDate = shipment?.estimated_delivery_date;
	const daysLeft = estimatedDeliveryDate ? Math.ceil((estimatedDeliveryDate - new Date()) / (1000 * 60 * 60 * 24)) : 0;

	return (
		<div className="flex flex-col">
			{shipment.done ? <h3 className="text-center mb-3">Delivered</h3> :
				<>
					<p className="uppercase text-sm font-bold text-darkGray">
						{estimatedDeliveryDate && shipment.status ?
							"Estimated delivery" :
							"CHECK BACK FOR AN ESTIMATED DELIVERY DATE"}
					</p>
					{estimatedDeliveryDate && !shipment?.status === "pre_transit" ? (
						<p className="text-2xl mb-4">{formatDateWithWeekday(estimatedDeliveryDate)}</p>
					) : (
						<h3 className="mb-4 text-center">Ready To Go</h3>
					)}
					{daysLeft > 0 && <p className="text-xl">{daysLeft} days left</p>}
				</>

			}
			<LatestActivity activity={shipment.scan_events.at(-1)} />
			{shipment.done && <CannotSeePackage />}
			{shipment.scan_events.length > 1 && <OrderStatusHistory activities={shipment.scan_events} />}
			<div className="flex gap-2 items-center">
				<img src={`https://cdn.gomalomo.com/images/carriers/${shipment.carrier}.svg`}
					alt={shipment.carrier_name} className="max-w-16 max-h-5" loading="lazy" />
				<span> {shipment.tracking_code}</span>
			</div>
		</div>
	);
};

export default OrderStatus;